export const マスタ = {
  請求書作成区分: "M0001",
  締日区分: "M0002",
  計上基準日区分: "M0003",
  請求車輌区分: "M0004",
  請求書印刷区分: "M0005",
  明細小計表示区分: "M0006",
  消費税表示区分: "M0007",
  消費税計算区分: "M0008",
  口座種別区分: "M0009",
  単位区分: "M0010",
  支払先区分: "M0011",
  採番区分: "M0012",
  明細ソート区分: "M0013",
  食事手当区分: "M0014",
  品名種別区分: "M0015",
  コース編集区分: "M0016",
  休日区分: "M0017",
  メニュー分類区分: "M0018",
  お知らせ分類区分: "M0019",
  締め確定区分: "M0020",
} as const

export const 受注配車_請求支払 = {
  受注配車区分: "T0001",
  配車状態区分: "T0002",
  付替区分: "T0003",
  稼働手当車種掛率区分: "T0004",
  同乗場所区分: "T0005",
  請求区分: "T0006",
  課税区分: "T0007",
  税込区分: "T0008",
  請求支払確認区分: "T0009",
  工程区分: "T0010",
  海コン付帯作業区分: "T0011",
  コンテナサイズ: "T0012",
  コンテナ軸: "T0013",
  請求支払処理状態区分: "T0014",
  金額区分: "T0015",
  受注配車入力表示順区分: "T0016",
  高速料入力区分: "T0017",
  受払区分: "T0018",
  請求明細一覧表示順区分: "T0020",
  海コン受注配車入力表示順区分: "T0019",
  距離設定区分: "T0021",
  運賃タリフ区分: "T0022",
  運賃単価設定区分: "T0023",
  AGC高速料対象荷主コード区分: "T0024",
  ETC紐づけ状態区分: "T0025",
  車輌経費区分: "T0026",
} as const

export const 車輌 = {
  車種区分: "C0001",
  陸運支局分類区分: "C0002",
  ETC設置区分: "C0003",
  車載装置区分: "C0004",
  点検整備区分: "C0005",
  タイヤ種類区分: "C0006",
  タイヤメーカー区分: "C0007",
  給油取込区分: "C0008",
  車輌営業所区分: "C0009",
} as const

export const 社員_乗務員 = {
  社員区分: "H0001",
  性別区分: "H0002",
  血液型区分: "H0003",
  入社区分: "H0004",
  安全管理区分: "H0005",
  適性診断種類区分: "H0006",
  指導懲戒区分: "H0008",
  適性診断判定結果区分: "H0009",
} as const

export const 経営管理 = {
  月間車輌収支車種区分: "K0001",
}

export const 運行管理_勤怠 = {
  出退勤区分: "U0001",
  勤怠区分: "U0002",
  休暇種別区分: "U0003",
  運行管理者区分: "U0004",
  天候区分: "U0005",
  点呼区分: "U0006",
  点呼方法区分: "U0007",
  指示事項区分: "U0008",
  共通指示事項区分: "U0015",
} as const

export const 外部ファイル = {
  取込ファイル区分: "F0001",
} as const

export const AyanasQuery = {
  公開範囲区分: "Q0001",
  フィルタ種別区分: "Q0002",
  比較演算子区分: "Q0003",
  接続条件区分: "Q0004",
  並替条件区分: "Q0005",
  フィールド型区分: "Q0006",
} as const

export const システム = {
  システム区分: "S0001",
} as const

export const 未選択 = {
  未選択: "Z9999",
} as const

export const 区分分類コード = {
  マスタ,
  受注配車_請求支払,
  車輌,
  社員_乗務員,
  運行管理_勤怠,
  経営管理,
  外部ファイル,
  AyanasQuery,
  システム,
  未選択: 未選択.未選択,
} as const

export const 区分分類コード一覧 = {
  ...マスタ,
  ...受注配車_請求支払,
  ...車輌,
  ...社員_乗務員,
  ...運行管理_勤怠,
  ...経営管理,
  ...外部ファイル,
  ...AyanasQuery,
  ...システム,
  ...未選択,
} as const

export type T区分分類プロパティ名称 = keyof typeof 区分分類コード一覧
export type T区分分類コード =
  (typeof 区分分類コード一覧)[T区分分類プロパティ名称]
